// key represent carrier color
export const BASE_KEY = 'base';

export const carrierColorMap: Record<string, Record<string, string>> = {
  lso: {
    base: '#0090CC',
    'lso-ground-service-method': '#0090CC',
    'lso-priority-next-day-service-method': '#1a9bd1',
    'lso-priority-next-day-simple-service-method': '#0082b8',
    'lso-economy-next-day-service-method': '#33a6d6',
    'lso-economy-next-day-simple-service-method': '#0073a3',
    'lso-second-day-service-method': '#00658f',
    'lso-second-day-simple-service-method': '#4db1db',
    'lso-ecomm-service-method': '#00567a',
  },
  ups: {
    base: '#732D02',
    'ups-next-day-air-early-service-method': '#9F6359',
    'ups-next-day-air-saver-service-method': '#9C4201',
    'ups-2nd-day-air-am-service-method': '#633501',
    'ups-2nd-day-air-service-method': '#633125',
    'ups-3-day-select-service-method': '#885425',
    'ups-ground-service-method': '#732D02',
    'ups-surepost-service-method': '#9F630A',
    'ups-surepost-lt-1lb-service-method': '#A16425',
    'ups-mail-innovations-method': '#582705',
  },
  fedex: {
    base: '#FF5E3F',
    'fedex-ground-service-method': '#C6390E',
    'fedex-home-delivery-service-method': '#FFA500',
    'fedex-smartpost-service-method': '#FF5E39',
  },
  cdl: {
    base: '#692659',
    'cdl-service-method': '#692659',
  },
  usps: {
    base: '#001B8799',
    'usps-priority-mail-service-method': '#006F98',
    'usps-parcel-select-service-method': '#00838F',
    'usps-priority-mail-express-service-method': '#001B87',
  },
  ontrac: {
    base: '#FFC30099',
    'ontrac-ground-service-method': '#FFC300',
    'ontrac-sunrise-service-method': '#FCFB00',
  },
};
